
import { defineComponent } from "vue";
import { ElMessage } from "element-plus";
import StationFormComponent from "@/components/stations/StationForm.component.vue";
import PageButtonsComponent from "@/components/PageButtons.component.vue";
import StationMapComponent from "@/components/stations/StationMap.component.vue";
import StationListComponent from "@/components/stations/StationList.component.vue";
import { Station } from "@/types";
import { getAvailableRoutes } from "@/service/user.service";
import { RootState } from "@/types/state.type";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  components: {
    PageButtonsComponent,
    StationMapComponent,
    StationListComponent,
    StationFormComponent,
  },

  data() {
    return {
      entitySelected: undefined as Station | undefined,
      showConfigEntityForm: false,
      showEntityForm: false,
      showMap: false,
    };
  },
  async mounted() {
    const store = useStore<RootState>();
    const route = useRoute();
    const router = useRouter();

    if (store.state.auth.user?.id) {
      try {
        let userRoutes = await getAvailableRoutes(store.state.auth.user.id);
        if (userRoutes.length > 0 && !userRoutes.includes(route.path)) {
          router.go(-1);
        }
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    }
  },
  methods: {
    /**
     * close samplingPoint formDialog
     */
    closeEntityDialog() {
      this.showEntityForm = false;
      this.showConfigEntityForm = false;
      this.entitySelected = undefined;
    },

    /**
     * save entity
     */
    async saveEntity() {
      // - call stationConfigForm save method
      await (this.$refs["stationForm"] as InstanceType<typeof StationFormComponent>)
        .doSave()
        .then(() => {
          // - close dialog and refresh
          this.closeEntityDialog();
          (
            this.$refs["stationList"] as InstanceType<typeof StationListComponent>
          ).refreshStations();
          ElMessage.success(this.$t("success.action"));
        });
    },

    /**
     * open entity form dialog
     * @param item
     */
    formEntityDialog(item: Station | undefined = undefined) {
      this.entitySelected = item;
      this.showEntityForm = true;
    },

    /**
     * changes the view to map or list
     */
    changeView() {
      this.showMap = !this.showMap;
    },
  },
});
